<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="academicLevelSummary && academicLevelProgress">
			<title-bar title="Progreso" :percentage="academicLevelSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<title-bar :title="academicLevelSummary.itemName" :percentage="academicLevelSummary.itemPercentage" percentageTitle="Promedio Nivel"/>
			<title-bar :title="category.name" :percentage="category.percentage" percentageTitle="Promedio Categoría" :categoryId="categoryId"/>
			<div class="row between innerRubric mt-5">
				<progress-chart v-for="question in progressionReport.questions" :key="question.id" :categoryId="categoryId" :data="question.graphData" :title="question.name" :percentage="question.percentage"/>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';

export default {
	props: ['academicLevelId', 'categoryId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	computed: {
		academicLevelSummary () {
			if (this.$store.state.academicLevels.summary) return this.$store.state.academicLevels.summary.find((item) => {
				return item.itemId == this.academicLevelId;
			});
			else return this.$store.state.academicLevels.summary;
		},
		academicLevelProgress () {
			if (this.$store.state.academicLevels.progress) return this.$store.state.academicLevels.progress.find((item) => {
				return item.academicLevel.id == this.academicLevelId;
			}).progress;
			else return this.$store.state.academicLevels.progress;
		},
		category () {
			if (this.academicLevelSummary) return this.academicLevelSummary.coachingCategories.find((category) => {
				return category.id == this.categoryId;
			});
			else return this.academicLevelSummary;
		},
		progressionReport () {
			if (!this.category) return [];
			this.category.questions.forEach((coachingQuestion) => {
				coachingQuestion.graphData = {
					labels: this.academicLevelProgress.map((visit) => {
						let result = null;
						visit.coachingCategories.forEach((category) => {
							if (category.id == this.categoryId) {
								category.questions.forEach((question) => {
									if (question.id == coachingQuestion.id) result = parseInt(question.percentage);
								});
							}
						});
						if (result) return `Visita ${visit.number}: ${result}%`;
						else return `Visita ${visit.number}`;
					}),
					datasets:	[{
						data: this.academicLevelProgress.map((visit) => {
							let result = null;
							visit.coachingCategories.forEach((category) => {
								if (category.id == this.categoryId) {
									category.questions.forEach((question) => {
										if (question.id == coachingQuestion.id) result = parseInt(question.percentage);
									});
								}
							});
							return result;
						}),
						borderWidth: 2,
						dates: this.academicLevelProgress.map((visit) => {
							return this.getHumanDate(visit.date);
						})
					}]
				};
			});
			return this.category;
		}
	},
	methods: {
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		}
	}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/routes/academicLevels/CategoryProgress.vue